import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenshotService {
  public readonly isCapturing = signal<boolean>(false);
}
